<template>
  <div v-if="getJobDetail != null">
    <div class="static-element-header">Job Description</div>
    <div class="static-element">{{getJobDetail}}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["getJobDetail"]),
  },
};
</script>

<style>
</style>